import { lazy } from 'react';

import { MenuItemConfig, ReactPageConfig } from '@intelliarts/ia-react-template';

import authConfig, { ANALYTICS_MENU_GROUP } from '../authConfig';
import { TurnoverSnapshotStore } from '../../components/turnover/store/turnoverSnapshotStore';
import { TurnoverYearlyTrendStore } from '../../components/turnover/store/turnoverYearlyTrendStore';

export const TurnoverPageConfig: ReactPageConfig = {
  name: 'src.config.routesConfigs.turnoverPageConfig.name',
  path: 'turnover-dashboard',
  component: lazy(() => import('../../components/pages/TurnoverDashboardPage')),
  allowedRoles: authConfig.roles.ALL,
  storeDependencies: [
    { store: TurnoverSnapshotStore },
    { store: TurnoverYearlyTrendStore },
  ],
  menuItemConfig: new MenuItemConfig({
    icon: lazy(() => import('@mui/icons-material/DonutLargeOutlined')),
    label: 'src.config.routesConfigs.turnoverPageConfig.label',
    group: ANALYTICS_MENU_GROUP,
    isCollapsibleGroup: true,
  }),
};
